export const BUSCA_ROUTER = '/pedido/busca';
